import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Register from "./Register";
import TeamList from "./TeamList";
import TeamSchedule from "./TeamSchedule";
import Standings from "./Standings";
import LeagueLeaders from "./LeagueLeaders";
import GameResults from "./GameResults";
import Player from "./Player";
import SaveList from "./SaveList";
import NewSave from "./NewSave";
import MyTeam from "./MyTeam";
import PlayGame from "./PlayGame";
import Settings from "./Settings";
import ResetPassword from "./ResetPassword";
import ForgotPassword from "./ForgotPassword";
import Dashboard from "./Dashboard";
import GameDetail from "./GameDetail";
import DraftBoard from "./DraftBoard";
import PlayerProgressionResults from "./PlayerProgressionResults";
import FreeAgents from "./FreeAgents";
import MidSeasonFreeAgents from "./MidSeasonFreeAgents";
import LiveGame from "./LiveGame";
import Landing from "./Landing";
import ProtectedRoute from "./ProtectedRoute";


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/landing" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="/draft" element={<ProtectedRoute element={<DraftBoard />} />} />
          <Route path="/free-agency" element={<ProtectedRoute element={<FreeAgents />} />} />
          <Route path="/mid-season-free-agents" element={<ProtectedRoute element={<MidSeasonFreeAgents />} />} />
          <Route path="/player-progression-results" element={<ProtectedRoute element={<PlayerProgressionResults />} />} />
          <Route path="/saves" element={<ProtectedRoute element={<SaveList />} />} />
          <Route path="/saves/new" element={<ProtectedRoute element={<NewSave />} />} />
          <Route path="/my-team" element={<ProtectedRoute element={<MyTeam />} />} />
          <Route path="/play-game" element={<ProtectedRoute element={<PlayGame />} />} />
          <Route path="/live-game" element={<ProtectedRoute element={<LiveGame />} />} />
          <Route path="/teams" element={<ProtectedRoute element={<TeamList />} />} />
          <Route path="/teams/:teamId/schedule" element={<ProtectedRoute element={<TeamSchedule />} />} />
          <Route path="/standings" element={<ProtectedRoute element={<Standings />} />} />
          <Route path="/league-leaders" element={<ProtectedRoute element={<LeagueLeaders />} />} />
          <Route path="/players/:playerId" element={<ProtectedRoute element={<Player />} />} />
          <Route path="/settings" element={<ProtectedRoute element={<Settings />} />} />
          <Route path="/results" element={<ProtectedRoute element={<GameResults />} />} />
          <Route path="/game-detail/:resultId" element={<ProtectedRoute element={<GameDetail />} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
